const _ = require('lodash');

function CatalogService(restangular) {
  this.api = restangular.all('Catalog');
  this.catalog = {
    categories: []
  };

  this.topLevelCategories = [
      {
          Attributes: {
              category_title: 'Beer',
              content_display: 'BeerMenuNavPromotion',
              department_link: 'beer',
              subdepartment_link: null,
              display_name: 'Beer',
              display_name_mobile: 'Beer & Cider',
              isEnabled: true,
              mob_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Mobile-Beer.png',
              desktop_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Desktop-Beer.png',
          }
      },
      {
          Attributes: {
              category_title: 'Wine',
              content_display: 'WineMenuNavPromotion',
              department_link: 'wine',
              subdepartment_link: null,
              display_name: 'Wine',
              display_name_mobile: 'Wine',
              isEnabled: true,
              mob_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Mobile-Wine.png',
              desktop_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Desktop-Wine.png',
          }
      },
      {
          Attributes: {
              category_title: 'Spirits',
              content_display: 'SpiritsMenuNavPromotion',
              department_link: 'spirits',
              subdepartment_link: null,
              display_name: 'Spirits',
              display_name_mobile: 'Spirits',
              isEnabled: true,
              mob_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Mobile-Spirits.png',
              desktop_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Desktop-Spirits.png',
          }
      },
      {
        Attributes: {
            category_title: 'Premix',
            content_display: 'PremixMenuNavPromotion',
            department_link: 'spirits',
            subdepartment_link: 'premixed-drinks',
            display_name: 'Premix',
            display_name_mobile: 'Premix',
            isEnabled: false,
            mob_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Mobile-Premix.png',
            desktop_icon: 'https://edgmedia.blob.core.windows.net/bws/media/assets/icons/Desktop-Premix.png',
        }
    },
      {
          Attributes: {
              category_title: 'Specials',
              content_display: 'SpecialsMenuNavPromotion',
              department_link: 'specials',
              subdepartment_link: null,
              display_name: 'Specials',
              display_name_mobile: 'Specials',
              isEnabled: true
          }
      },
      {
        Attributes: {
            category_title: 'The Drop',
            department_link: 'the-drop',
            web_link: 'shop.thedrop',
            subdepartment_link: null,
            display_name: 'The Drop',
            display_name_mobile: 'The Drop',
            isEnabled: true
        }
        }
    ];
}

CatalogService.prototype.flatternCategoriesAttributes = function (result) {
   // transform the categories attributes to an object key/value
   return _.map(result.Categories, function (category) {
      const attributes = {};
      for (const key in category.Attributes) {
          if (category.Attributes.hasOwnProperty(key)) {
              attributes[category.Attributes[key].Name] = category.Attributes[key].Value;
          }
      }
      category.Attributes = attributes;
      return category;
    });
};

CatalogService.prototype.getCategories = function (request) {
  return this.api.get('Categories', request).then(this.flatternCategoriesAttributes).then((categories) => {
     this.catalog.categories = categories;
     return this.catalog.categories;
  });
};

module.exports = CatalogService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/catalog/catalog-service.js
 **/